import { Button, Container, Drawer, Portal, Text } from '@chakra-ui/react';
import { EnrollmentList } from './EnrollmentList';

export const BasketDrawer = ({ lessonsList, setLessonsList, onClose, isOpen }: any) => {
    return (
        <Drawer.Root
            placement='bottom'
            open={isOpen}
            onOpenChange={e => {
                if (!e.open) {
                    onClose();
                }
            }}>
            <Portal>
                <Drawer.Backdrop />
                <Drawer.Positioner>
                    <Drawer.Content h="calc(100vh - 108px)">
                        <Drawer.Header display="flex" justifyContent="space-between" alignItems="center">
                            <Text fontWeight="semibold">Wybrane zajęcia</Text>
                            <Drawer.CloseTrigger asChild>
                                <Button variant="ghost" color="gray.600">Zamknij</Button>
                            </Drawer.CloseTrigger>
                        </Drawer.Header>
                        <Drawer.Body>
                            {!lessonsList.length && (
                                <Container centerContent>
                                    <Text fontStyle="italic">
                                        Brak wybranych terminów do wyświetlenia...
                                    </Text>
                                </Container>
                            )}
                            <EnrollmentList
                                lessonList={lessonsList}
                                actionType="remove"
                                onRemove={(index: number) =>
                                    setLessonsList(
                                        lessonsList.toSpliced(index, 1)
                                    )
                                }
                                onUpdate={(index: number, nextNotes: string) =>
                                    setLessonsList((previousLessons) =>
                                        previousLessons.map((lesson, lessonIndex) =>
                                            lessonIndex === index ? { ...lesson, notes: nextNotes } : lesson
                                        )
                                    )
                                }
                            />
                        </Drawer.Body>
                    </Drawer.Content>
                </Drawer.Positioner>

            </Portal>
        </Drawer.Root>
    );
};
